import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { payslipViewTourSteps } from "./payslipViewTourSteps";

type PayslipViewTourProps = {
  run: boolean;
  onCallback: (data: { status?: string; type?: string }) => void;
};

export function PayslipViewTour({ run, onCallback }: PayslipViewTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type });
  };

  return (
    <Joyride
      steps={payslipViewTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export { usePayslipViewTour } from "./usePayslipViewTour";
